import React, { useContext, useEffect, useState } from 'react';
import DOMPurify from 'dompurify';
import { AppContext } from '../context/AppContext';
import { useNavigate, useParams } from 'react-router-dom';
import { SCNavbar } from '../components/Navbar';
import { Helmet } from 'react-helmet';
import { Button } from 'react-bootstrap';

const GenericPage: React.FC = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error("AppContext must be used within an AppProvider");
  }

  const { state, updateScientificCommittee } = context;
  const { scientificCommittee, pageId } = useParams<{ scientificCommittee: string; pageId: string }>();
  const { data } = state;
  const [selectedPage, setSelectedPage] = useState<any>(null);
  const [canonical, setCanonical] = useState<string>('');
  const navigate = useNavigate();

  useEffect(() => {
    if (scientificCommittee) {
      updateScientificCommittee(scientificCommittee);
    }
  }, [scientificCommittee, updateScientificCommittee]);

  useEffect(() => {
    if (!data || !pageId ) return;
    const page = data.pages?.find((page: any) => page.pageId === pageId);
    if (page) {
      setSelectedPage(page);
      setCanonical(getCanonical());
    }
  }, [data, pageId]);


  const getCanonical = (): string => {
    return `${process.env.REACT_APP_BASE_PATH}/${scientificCommittee}/${pageId}`;
  }

  if (!selectedPage) {
    return <p className="text-center">Page not available</p>;
  }

  return (
    <>
      <Helmet>
        <title>{selectedPage.title} | ICOH - International Commission on Occupational Health</title>
        <meta name="description" content={selectedPage.description || selectedPage} />
        <link rel="canonical" href={canonical} />
      </Helmet>
      <SCNavbar scientificCommittee={scientificCommittee} section={selectedPage.type} />
      <div className="container py-4 flex-grow-1">
        {(selectedPage.period || selectedPage.place) && <div className="h4 mb-2 text-secondary">
          {selectedPage.period} 
          {selectedPage.period && selectedPage.place && <span className="mx-2">-</span>}
          {selectedPage.place}
        </div>}
        <h1>{selectedPage.title}</h1>
        <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(selectedPage.text) }}></div>
        {selectedPage.nextPageId && (
          <div className="mt-4">
            <Button onClick={() => navigate(`/${scientificCommittee}/${selectedPage.nextPageId}`)}  className="btn btn-primary">
              Next: {selectedPage.nextPageTitle}
            </Button>
          </div>
        )}
      </div>
    </>
  );
};

export default GenericPage;
